import { init } from '@visma/formula/lib/dll';
import React, { useEffect } from 'react';
import Loader from '../components/Loader';
import FormulaConfig from '../utils/FormulaConfig';

const defaultState = {
  initialized: false,
  initializationError: false,
  initializeFormula: async () => {
    throw Error('AccessTokenContext not initialized');
  }
}

export const FormulaContext = React.createContext(defaultState);
const FormulaContextProvider = ({ formulaUrl, children }) => {
  const [formulaState, setFormulaState] = React.useState(defaultState);

  const initializeFormula = async () => {
    try {
      await init(formulaUrl);
      setFormulaState({
        initialized: true,
        initializationError: false,
        initializeFormula,
      });
    } catch (error) {
      console.log(error);
      setFormulaState({
        initialized: false,
        initializationError: true,
        initializeFormula: async () => {
          throw Error('AccessTokenContext not initialized');
        }
      });
    }
  }

  useEffect(() => {
    initializeFormula();
  }, []);

  return (
    <FormulaContext.Provider value={formulaState}>
      {formulaState.initialized ? (
        <FormulaConfig formulaUrl={formulaUrl}>
          {children}
        </FormulaConfig>
      ) : <Loader />}
    </FormulaContext.Provider>
  );
}

export default FormulaContextProvider;